import DefaultFormButton from './DefaultFormButton';
import generateRender from 'shared/utils/generateRender';

const FormButton = generateRender({
  default: DefaultFormButton,
});

export default FormButton;

